import axios from "axios";
import {API_URL_V1} from "./staticData";
import Cookies from "js-cookie";

export const axiosConfig = axios.create({
    baseURL: API_URL_V1,
    headers: {Authorization: `Bearer ${Cookies.get('token')}`}
})